const apiClient = require('../graphql/apiClient')
const { hideRadarArea, isViewEnabled, initialisePage, hideLoader, getRootContent } = require('../utils/headers')

const _ = {
  map: require('lodash/map'),
  groupBy: require('lodash/groupBy'),
  each: require('lodash/each'),
}

const { gql } = require('graphql-tag')

const PUBLICATIONS_QUERY = gql`
  query previousPublications {
    publications {
      name
    }
  }
`

const VIEW_MODE = 'publications'

function renderView() {
  if (isViewEnabled(VIEW_MODE)) {
    hideRadarArea()

    initialisePage('Publications', '')

    let bodyText = ''

    apiClient(PUBLICATIONS_QUERY)
      .then((res) => res.json())
      .then((result) => {
        let groupedPublications = _.groupBy(result.data.publications, function (publication) {
          return publication.name.split('-')[0]
        })

        _.map(groupedPublications, function (value, key) {
          bodyText += `<h4>${key}</h4>`

          _.each(value, function (publication) {
            bodyText += `<div><a href="/?publicationName=${publication.name}">${publication.name}</a></div>`
          })
          bodyText += '<br />'
        })
      })
      .then(() => {
        hideLoader()
        getRootContent().append('div').attr('align', 'center').html(bodyText)

        getRootContent().append('div').html('<hr />')
      })
  }
}

module.exports = renderView
